module.exports = __webpack_public_path__ + "img/SKMJ_etc11.3ab1a927.jpg";